import React from "react";
import {observer} from "mobx-react";

import "./measurements-info-section.scss";

import {Table} from "semantic-ui-react";

import {Station} from "../../../../../../kiwis";
import {
    MeasurementInfoConfiguration,
    MeasurementsInfoConfiguration
} from "../../../../../../config/measurements-info-configuration";
import {MeasurementInfoTableRow} from "./measurement-info-table-row/measurement-info-table-row";

interface MeasurementInfoSectionProps {
    station: Station;
    config: MeasurementsInfoConfiguration;
    title: number[];
    description: string;
    id: string;
    headings: { [key: string]: string };
    dateFormat: string;
    timeFormat: string;
    measurements: string[];
    divider: boolean;
}

@observer
export class MeasurementInfoSection extends React.Component<MeasurementInfoSectionProps, any> {
    constructor(props: MeasurementInfoSectionProps) {
        super(props);
        this.state = {
            updating: false
        };
    }

    componentDidMount() {
    }

    componentWillUnmount() {
        // TODO remove watches
    }

    render() {
        const {config, dateFormat, description, divider, headings, measurements, station, timeFormat, title} = this.props;

        // select measurements for this section
        const sectionMeasurements = config.measurements.filter((measurement: MeasurementInfoConfiguration) =>
            measurements.includes(measurement.key)
        );

        const rows = sectionMeasurements.map((measurementInfo: MeasurementInfoConfiguration) => {
            const measurement = station.currentMeasurements.get(measurementInfo.key);
            if (!measurement) {
                return null;
            }
            return (
                <MeasurementInfoTableRow
                    stationId={station.id}
                    dateFormat={dateFormat}
                    timeFormat={timeFormat}
                    {...measurementInfo}
                    {...measurement}
                    key={`measurements-pane-table-row-${measurementInfo.key}`}
                />
            );
        });

        // only display sections with measurements
        if (rows.filter(Boolean).length <= 0) {
            return null;
        }

        return (
            <div className="geo-measurements-section">
                <span>{title}</span>
                <Table basic="very" celled unstackable className={"geo-measurements-pane-table"}>
                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell>{headings["parameter"]}</Table.HeaderCell>
                            <Table.HeaderCell>{headings["measurement"]}</Table.HeaderCell>
                            <Table.HeaderCell>{headings["date"]}</Table.HeaderCell>
                        </Table.Row>
                    </Table.Header>
                    <Table.Body>
                        {rows}
                    </Table.Body>
                </Table>
                <span className="geo-measurements-section-description">{description}</span>
                {divider ? <hr/> : null}
            </div>
        );
    }
}
